import React from 'react';

const skills = [
  {
    category: "Programming Languages",
    items: [
      { name: "Python", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
      { name: "Java", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" },
      { name: "C", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg" },
      { name: "JavaScript", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" }
    ]
  },
  {
    category: "Web Development",
    items: [
      { name: "HTML", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" },
      { name: "CSS", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" },
      { name: "React", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { name: "Node.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
      { name: "Express.js", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" }
    ]
  },
  {
    category: "Data Science & ML",
    items: [
      { name: "Pandas", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg" },
      { name: "NumPy", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg" },
      { name: "TensorFlow", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg" },
      { name: "scikit-learn", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/scikit-learn/scikit-learn-original.svg" },
      { name: "Matplotlib", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Matplotlib_icon.svg/1200px-Matplotlib_icon.svg.png" }
    ]
  },
  {
    category: "Databases",
    items: [
      { name: "SQL", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
  
    ]
  },
  {
    category: "Tools",
    items: [
      { name: "GitHub", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg" },
      { name: "VS Code", logo: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg" }
    ]
  },
  {
    category: "Soft Skills",
    items: [
      { name: "Leadership", logo: "https://cdn-icons-png.flaticon.com/512/3281/3281289.png" },
      { name: "Communication", logo: "https://cdn-icons-png.flaticon.com/512/2946/2946177.png" },
      { name: "Prompt Engineering", logo: "https://cdn-icons-png.flaticon.com/512/1055/1055687.png" }
    ]
  }
];

const Skills = () => {
  return (
    <section id="skills" className="relative py-20 px-6 overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-[15%] w-24 h-24 border-4 border-blue-400/10 rounded-lg animate-float-1"></div>
        <div className="absolute bottom-1/3 right-[20%] w-20 h-20 border-3 border-blue-400/10 rounded-full animate-float-2"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
            My Skills
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Technologies I work with and competencies I've developed
          </p>
        </div>

        {/* Interactive Skills Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {skills.map((category, catIdx) => (
            <div 
              key={catIdx} 
              className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-2xl border border-gray-700/50 hover:border-blue-400/30 transition-all duration-300 shadow-lg hover:shadow-blue-500/20"
            >
              <h3 className="text-xl font-bold mb-6 text-white border-b border-blue-500/30 pb-2">
                {category.category}
              </h3>
              
              <div className="grid grid-cols-2 gap-4">
                {category.items.map((skill, skillIdx) => (
                  <div 
                    key={skillIdx} 
                    className="skill-card group flex flex-col items-center p-4 rounded-lg hover:bg-gray-700/50 transition-all duration-200"
                  >
                    <div className="w-16 h-16 mb-3 flex items-center justify-center bg-gray-700/50 rounded-lg group-hover:bg-blue-500/10 transition-all">
                      <img 
                        src={skill.logo} 
                        alt={skill.name} 
                        className="h-10 w-10 object-contain" 
                        onError={(e) => {
                          e.target.onerror = null; 
                          e.target.src = "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/github/github-original.svg";
                        }}
                      />
                    </div>
                    <span className="text-gray-300 text-center text-sm font-medium group-hover:text-white transition-colors">
                      {skill.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Leadership Highlight */}
        <div className="mt-16 bg-gradient-to-r from-blue-900/30 to-cyan-900/30 p-8 rounded-2xl border border-blue-500/20 shadow-lg">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="md:w-1/3 text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-600/20 text-blue-400 text-3xl mb-4">
                👨‍💼
              </div>
              <h3 className="text-2xl font-bold text-white">Leadership & Communication</h3>
            </div>
            <div className="md:w-2/3">
              <ul className="space-y-4 text-gray-300">
                <li className="flex items-start gap-3">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Served as <span className="text-white font-medium">Secretary of IEEE Student Branch</span>, organizing 15+ technical events including international conferences</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Recipient of the <span className="text-white font-medium">Community Service Award</span> for leadership contributions</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Experienced in <span className="text-white font-medium">team leadership</span> and <span className="text-white font-medium">technical communication</span> for complex projects</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>Skilled in <span className="text-white font-medium">prompt engineering</span> to effectively communicate with AI systems</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Animation styles */}
      <style jsx global>{`
        @keyframes float-1 {
          0%, 100% { transform: translateY(0) rotate(12deg) scale(1); }
          50% { transform: translateY(-25px) rotate(12deg) scale(1.05); }
        }
        @keyframes float-2 {
          0%, 100% { transform: translateY(0) scale(1); }
          50% { transform: translateY(20px) scale(1.1); }
        }
        .animate-float-1 { animation: float-1 7s ease-in-out infinite; }
        .animate-float-2 { animation: float-2 6s ease-in-out infinite; }

        .skill-card:hover img {
          transform: scale(1.1);
          transition: transform 0.3s ease;
        }
      `}</style>
    </section>
  );
};

export default Skills;